<script setup>

import { Link } from "@inertiajs/vue3";

</script>

<template>
	<div class="result">
		<Link :href="url" class="d-flex align-items-center justify-content-between">

		<div class="text_wrapper d-grid align-items-center">
			<i class="lnr icon-heart" style="color: #ee221d" v-if="is_favorite"></i>
			<span class="text-center result-title" v-text="title"></span>
			<span class="result-price ml-5 font-semibold text-primary" v-if="price > 0 && !$page.props.store.is_b2b">
				{{ price }} {{ $page.props.store.currency_symbol || $page.props.store.currency_code }}
			</span>
		</div>

		<div class="product-image-wrapper">
			<img class="product_image" :src="image" alt="">
		</div>

		</Link>
	</div>
</template>

<script>
export default {
	name: 'Product',
	props: ['search_result', 'action', 'is_favorite', 'locale'],
	mounted() {

	},

	computed: {

		title() {
			return this.search_result['title_' + this.locale];
		},

		description() {
			let description_full = this.search_result['description_' + this.locale];
			return description_full.length > 100 ? description_full.slice(0, 100) : description_full;
		},

		url() {
			return '/' + this.search_result['slug_' + this.locale];
		},

		price() {
			return this.search_result['price_new'];
		},

		image() {
			return '/storage/product_image' + this.search_result.image;
		}

	},

	methods: {




	}

}
</script>
